import  { useState } from "react";
import axiosService from "../../../utils/axios.service";
import "../scss/report.scss"
import { Table, Button } from 'antd';
import 'antd/dist/antd.min.css'
import Loading from "../../customer/Loading";

const ReportBHVVDetail = (props) => {    
    const [showLoading, setShowLoading] = useState(false)
    const [pageSize, setPageSize] = useState(10)
    const [locationsWidth, setLocationsWidth] = useState(window.innerWidth)

 
    function convertCurrency(data) {
        let res = new Intl.NumberFormat('vi-VN', { style: 'currency', currency: 'VND' }).format(data)
        return res;
    };
    var wdt = 200
    if (locationsWidth < 765 ) {
        wdt = 130
    }

    const columns = [
        { 
            dataIndex: 'product_name', 
            title: 'Tên dịch vụ', 
            fixed:'left',
            sorter: (a, b) => a.product_name - b.product_name,
        },
        {
            dataIndex: 'total_used',
            title: 'Số lượt phục vụ',
            align: "center",
            sorter: (a, b) => a.total_used - b.total_used,
        },
        {
            dataIndex: 'total_amount',
            title: 'Tổng chi phí',
            align: "center",
            render: (data) => {
                return (
                    <p className="text7">{convertCurrency(data)}</p>
                )
            },
            sorter: (a, b) => a.total_amount - b.total_amount,
        }
    ];

    const handelExportData = () => {
        setShowLoading(true)
        var url = `api/reports-view/export-tracking-bhvv?storeId=${props.store}&startDate=${props.startDate}&endDate=${props.endDate}`
        axiosService(url, "GET")
        .then((res) => {
            if (res.data.code == 200) {
                window.open(res.data.data.url, '_blank');
                setShowLoading(false)
            }
        }).catch((error) => {
            console.log(error)
            setShowLoading(false)
        });
    }

    const  handleChange = (e) => {
        setPageSize(e.pageSize)
    }
  
    return (
        <>
            <div style={{ backgroundColor: "white" }}>
                
                <div className="border-bottom w-100 pb-2">
                    <div className="d-flex justify-content-between">
                        Bảng số liệu theo từng dịch vụ
                        <Button size="middle" type="primary" onClick={handelExportData}>
                            <i className="fa-solid fa-file-excel mr-2"></i>Xuất Excel
                        </Button>
                    </div>
                </div>
                    
                <Table 
                    columns={columns} 
                    dataSource={props.table}
                    pagination={{ pageSize: pageSize, showSizeChanger: true, pageSizeOptions: ['10', '15', '30', '50', '100'] }}
                    scroll={{ x: columns.length*150, y: 600 }}
                    rowKey="store_name"
                    onChange={handleChange}
                    bordered
                />
            </div>
            <Loading show={showLoading}></Loading>
        </>
    )
}
export default ReportBHVVDetail